import axios from 'axios';

// 20 seconds timeout
const customAxios = axios.create({
  timeout: 20000,
});

// Add custom headers
const requestHandler = (request: any) => {
  request.headers = {
    ...request.headers,
    Authorization: 'Basic ' + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ':' + process.env.REACT_APP_API_AUTH_PASSWORD),
    jwt: localStorage.getItem('jwt'),
  }

  return request;
};

const responseHandler = (response: any) => {
  return response;
};

const errorHandler = (error: any) => {
  return Promise.reject(error);
};

// 401 = session expired or invalid: drop the token and go to the login page.
// /login itself answers 401 for wrong credentials, which the login screen handles.
const responseErrorHandler = (error: any) => {
  const isLoginRequest = /\/login$/.test(error?.config?.url || '');

  if (error?.response?.status === 401 && !isLoginRequest) {
    localStorage.removeItem('jwt');
    window.location.href = '/login';

    // never settle, so screens don't show an error message while the page navigates away
    return new Promise(() => {});
  }

  return Promise.reject(error);
};

customAxios.interceptors.request.use(
  (request) => requestHandler(request),
  (error) => errorHandler(error)
);

customAxios.interceptors.response.use(
  (response) => responseHandler(response),
  (error) => responseErrorHandler(error)
);

export default customAxios;
